import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TabletAndroidIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tablet_android"}/>
}
